import React from 'react';

import ContentCertificate from '@/modules/corporate/modules/certificates/components/ContentCertificate';
import { CertificateDimensions, CertificateTemplateType, CertificateType } from '@/types/schema';

import { QuizDetailsContentFragment } from '../../graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '../../graphql/fragments/generated/QuizDetailsPerformance';

interface CertificateProps {
  quiz: QuizDetailsContentFragment;
  quizPerformance?: QuizDetailsPerformanceFragment;
  className?: string;
  externalCertificateDimensions?: CertificateDimensions;
}

const Certificate: React.FC<CertificateProps> = React.memo(
  ({ className, quiz, externalCertificateDimensions, quizPerformance }) => (
    <ContentCertificate
      certificateSettings={quiz.certificateSettings}
      certificateTemplate={quiz.certificateTemplate as CertificateTemplateType}
      className={className}
      contentName={quiz.name}
      externalCertificateDimensions={externalCertificateDimensions}
      issuedCertificate={quizPerformance?.issuedCertificate as CertificateType}
    />
  ),
);

export default React.memo(Certificate);
